<template>
	<div class="clear cp">
		<ClientOnly>
			<span v-if="item?.priority_details?.code == 'new'" class="cp-badge new">Novo</span>
			
			<div v-if="hasSpecialBadges || Object.keys(item?.badge_coupons || {}).length" class="cp-badges-container">
				<template v-if="hasSpecialBadges">
					<template v-for="(attr, index) in item.attributes_special.filter(a => a.attribute_code === 'posebne_oznake').slice(0, 4)" :key="index">
						<div v-if="attr.image_upload_path" class="cp-badge">
							<figure :class="['cp-badge-image', attr.code]">
								<BaseUiImage loading="lazy" :src="attr.image_upload_path" default="/images/no-image-50.jpg" :alt="attr.title ? attr.title : ''" />
							</figure>
							<div v-if="attr.title" class="cp-badge-title">{{attr.title}}</div>
						</div>
					</template>
				</template>
				
				<template v-if="Object.keys(item?.badge_coupons || {}).length">
					<template v-for="(coupon, id) in item?.badge_coupons" :key="id">
						<div class="cp-badge" v-if="coupon.image">
							<div class="cp-badge-image" v-if="coupon.image">
								<BaseUiImage loading="lazy" :src="'/upload/'+coupon.image" default="/images/no-image-50.jpg" :alt="coupon.description" />
							</div>						
						</div>
					</template>
				</template>				
			</div>
		</ClientOnly>
        
        <figure class="cp-image">
			<NuxtLink :to="item.url_without_domain" @click="gtmTrack('selectItem', {items: item})">
				<BaseUiImage loading="lazy" :data="item.main_image_thumbs?.['width300-height360']" default="/images/no-image-300.jpg" :title="item.main_image_title" :alt="item.main_image_description ? item.main_image_description : ''" />
			</NuxtLink>	

            <ClientOnly>
				<CatalogSpecialBadges v-if="hasSpecialBadges || item.discount_percent_custom > 0 || (Object.keys(item?.badge_coupons || {}).length)" :item="item" :hasSpecialBadges="hasSpecialBadges" />
			</ClientOnly>
		</figure>

        <ClientOnly>
			<CatalogSetWishlist v-if="mode != 'wishlist'" :item="item" />
		</ClientOnly>

        <div class="clear cp-cnt">
			<ClientOnly>
                <template v-if="item?.feedback_rate_widget && item.feedback_rate_widget?.rates_status > 1 && item.feedback_rate_widget?.rates_votes > 0 && item.feedback_rate_widget?.rates">
					<div class="cp-rates">
						<FeedbackRates :rates="item.feedback_rate_widget.rates" />
					</div>
				</template>
			</ClientOnly>

            <div v-if="item.manufacturer_url && item.manufacturer_url_without_domain && item.manufacturer_title" class="cp-brand">
                <NuxtLink :to="item.manufacturer_url_without_domain">{{item.manufacturer_title}}</NuxtLink>
            </div>

            <h2 v-if="item.title" :class="['cp-title', !item.manufacturer_url && 'cp-title-no-brand']"><NuxtLink :to="item.url_without_domain" @click="gtmTrack('selectItem', {items: item})">{{item.title}}</NuxtLink></h2>
       
            <div v-if="item.price_custom && item.price_custom > 0" class="cp-price">
                <template v-if="(item.discount_percent > 0 || item.price_custom < item.basic_price)">
                    <div class="cp-discount-price"><BaseUtilsFormatCurrency :price="item.price_custom" /></div>
                </template>
                <template v-else>
                    <div class="cp-old-price"></div>
                    <div class="cp-current-price"><BaseUtilsFormatCurrency :price="item.price_custom" /></div>
                </template>

                <CatalogUnitPrice :item="item" mode="cp-unit" />

				<span v-if="item.extra_price_lowest && (item.discount_percent || item.discount_percent_custom) && item.extra_price_lowest != 0" class="cp-extra-price-lowest"><BaseCmsLabel code="extra_price_lowest" />: <strong><BaseUtilsFormatCurrency :price="item.extra_price_lowest" /></strong></span>
                <span v-else class="cp-extra-price-lowest-empty"></span>

                <ClientOnly>
					<WebshopAddToCartContainer :item="item" mode="cp" />
				</ClientOnly>
            </div>
        </div>
	</div>

	<ClientOnly>
		<article v-if="promoItem?.image_upload_path" class="cp cp-promo">
			<NuxtLink v-if="promoItem?.url_without_domain" :to="promoItem.url_without_domain">
				<figure>
					<span><BaseUiImage loading="lazy" :data="promoItem.image_thumbs?.['width348-height538-crop1']" default="/images/no-image-300.jpg" :alt="promoItem.title" /></span>
				</figure>
			</NuxtLink>
			<figure v-else>
				<span><BaseUiImage loading="lazy" :data="promoItem.image_thumbs?.['width348-height538-crop1']" default="/images/no-image-300.jpg" :alt="promoItem.title" /></span>
			</figure>
		</article>
	</ClientOnly>
</template>

<script setup>
	const {gtmTrack} = useGtm();
	const props = defineProps(['item', 'mode', 'order', 'promo']);

    const hasSpecialBadges = computed(() => {
        return props.item?.attributes_special?.some(a => a.attribute_code === 'posebne_oznake');
    });

	const promoItem = computed(() => {
		if(!props.promo?.length) return null;
		if(props.order == 2 && props.promo[0]) return props.promo[0];
		if(props.order == 5 && props.promo[1]) return props.promo[1];
		if(props.order == 12 && props.promo[2]) return props.promo[2];
	});
</script>